//@ts-ignore
import { getUser } from '@/services/server/fetchers/users';
import { ADMIN } from '@/constants/roles.constant';
import { VIEW_ALL_DOMAINS } from '@/constants/permissions.constant';
import { Permission, Role, useAppDispatch, useAppSelector, setUser, UserState } from "@/store";
import { isAwaitingDomainAccess } from '@/utils/userAccess';

export const useUser = () => {
    const user: UserState = useAppSelector((state) => state.auth.user);
    const dispatch = useAppDispatch();
    const userRoles = user?.roles?.map(({title}) => title) ?? [];
    const userPermissions = getPermissionsFromRoles(user?.roles ?? []);

    const resetUser = async () => {       
        const res: any = await getUser(user.token, user?.id);
        delete res.user.createdAt;
        delete res.user.updatedAt;
        dispatch(setUser({...user, ...res.user, token: user.token}))
    }

    const hasPermission = (permission: string) => {
        return userPermissions.includes(permission);
    }
    
    const hasRole = (roleTitle: string) => {
        return userRoles?.includes(roleTitle);
    }

    const isAuthorized = ( authority: string[] | undefined ) => {
        if(!authority || (authority && authority.length === 0) ) return true;
        return authority.some((a) => hasPermission(a) || hasRole(a));
    }

    const canViewAllDomains = hasRole(ADMIN) || hasPermission(VIEW_ALL_DOMAINS);
    const awaitingDomainAccess = isAwaitingDomainAccess(canViewAllDomains, user?.domains);
    
    
    return {
        hasPermission,
        hasRole,
        canViewAllDomains,
        awaitingDomainAccess,
        userPermissions,
        userRoles,
        token: user?.token,
        user,
        isAuthorized,
        resetUser,
        userDomains: user?.domains
    };
}

export const getPermissionsFromRoles = (roles: Role[] = []) => {
    const permissionsSet = new Set<string>();
    roles.forEach(({permissions}) => {
       permissions.forEach((permission: Permission) => {
            permissionsSet.add(permission.title);
       });
    });
    return Array.from(permissionsSet);
}